import { NavLink } from 'react-router-dom';

const LIENS: ReadonlyArray<[string, string]> = [
  ['/administration/comptes', 'Comptes et rôles'],
  ['/administration/referentiels', 'Points de vente et métiers'],
  ['/administration/baremes', 'Barèmes'],
  ['/administration/journal', 'Journal'],
  ['/parametres', 'Paramètres'],
];

/** Onglets des pages d'administration (docs/UI.md § Écran 6), super admin seulement. */
export function NavAdministration() {
  return (
    <nav className="sous-nav" aria-label="Administration">
      {LIENS.map(([vers, libelle]) => (
        <NavLink key={vers} to={vers}>
          {libelle}
        </NavLink>
      ))}
    </nav>
  );
}
